module.exports = __webpack_public_path__ + "static/media/General_Meeting.66a0c09f.md";